export default {
  JOURNAL: 'Journal',
  THESIS: 'Thesis',
  BOOK: 'Book',
  RESUME: 'Resume',
  COVER_LETTER: 'Cover Letter',
  CAREER_FINANCIALS: 'Career Financials',
  AI_MOCK_INTERVIEW: 'AI Mock Interview',
};

/**
 * This is redundant but because we followed multiple conventions for representing format types,
 * we had no other choice but to go according to API
 */
export const TitleToCapital = {
  Journal: 'JOURNAL',
  Thesis: 'THESIS',
  Book: 'BOOK',
  Resume: 'RESUME',
  'Cover Letter': 'COVER_LETTER',
};

export const TitleToCamel = {
  Resume: 'resumeType',
  'Cover Letter': 'coverLetterType',
};
